import { useState } from 'react';

export type DataUpdate<Params extends Array<unknown> = Array<unknown>, Res = void> = (
	...arg: Params
) => Promise<Res>;

type UseDataUpdateRes<Params extends Array<unknown> = Array<unknown>, Res = void> = {
	loading: boolean;
	update: DataUpdate<Params, Res>;
};

const useDataUpdate = <Params extends Array<unknown> = Array<unknown>, Res = void>({
	api,
}: {
	api: DataUpdate<Params, Res>;
}): UseDataUpdateRes<Params, Res> => {
	const [loading, setLoading] = useState<boolean>(false);

	const update: DataUpdate<Params, Res> = (...args) => {
		setLoading(true);
		return new Promise<Res>((resolve, reject) => {
			api(...args)
				.then((res) => resolve(res))
				.catch((error) => reject(error))
				.finally(() => setLoading(false));
		});
	};

	return { loading, update };
};

export default useDataUpdate;
